import React, { Component } from 'react';

import { initBootstrapSelect } from '../../../../../Shared/js/vendor/deferred';
import Actions from '../../actions/TabletsActions';
import Filters from '../filters/Filters';

export default class Search extends Component {
    constructor(props) {
        super(props);
        this.state = props.state;
        this.filters = props.filters;
        this.results = props.results;
        this.widenResults = props.widenResults;
        this.resultsUrl = props.resultsUrl;
        this.searchUrl = props.searchUrl;
        this.coverageUrl = props.coverageUrl;
        this.embeddedMode = props.embeddedMode;
        this.actions = new Actions(this);
    }

    async componentDidMount() {
        await initBootstrapSelect();
        this.actions.bindResults();
        if (this.embeddedMode === 'None') {
            this.actions.trackPage(false);
        }
    }

    render() {
        const filterComponent =
            this.filters && this.filters !== null ? (
                <Filters
                    {...this.filters}
                    suppliers={this.state.suppliers}
                    criteria={this.state.criteria}
                    modal={this.state.modal}
                    unavailableConnectionTypes={this.state.unavailableConnectionTypes}
                    actions={this.actions}
                ></Filters>
            ) : null;

        return (
            <React.StrictMode>
                <React.Fragment>{filterComponent}</React.Fragment>
            </React.StrictMode>
        );
    }
}
